<template>
  <ValidationObserver>
    <div>
      <b-alert v-if="errorAlert" variant="warning" show>
        <div class="text-dark" v-html="errorAlert"></div>
      </b-alert>

      <div class="mb-3">
        <div class="mb-5">
          <label class="font-size-h4 font-weight-bold">
            {{ title || 'Upload New Claims History (Excel / CSV / PDF)' }}
          </label>
<!--          <span class="float-right">-->
<!--            <a class="btn btn-sm float-right text-dark" href="" target="_blank">-->
<!--              <i class="fa fa-sm fa-download"></i>Sample Template-->
<!--            </a>-->
<!--          </span>-->
        </div>
        <div class="form-group row">
          <div class="col-8">
            <ValidationProvider rules="" name="selectedFiles" v-slot="{ errors }">
              <b-form-file class="form-control" placeholder="Drop files here, or click here to select files"
                           v-model="selectedFiles" multiple accept=".xlsx,.csv,.pdf">
                <template slot="file-name" slot-scope="{ names }">
                  <b-badge variant="secondary">{{ names[0] }}</b-badge>
                  <b-badge v-if="names.length > 1" variant="secondary" class="ml-1">
                    + {{ names.length - 1 }} More files
                  </b-badge>
                </template>
              </b-form-file>
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <button class="ml-3 btn btn-primary font-weight-bold" @click.prevent="uploadFiles"
                  :disabled="!Array.isArray(this.selectedFiles) || this.selectedFiles.length === 0">
            <i class="fa fa-upload"></i> Upload Files
          </button>
        </div>
      </div>

      <div v-if="extractionJobRunning">
        <div class="form-group row mb-0">
          <div class="col-12">
            <b-spinner class="align-middle mr-2" variant="primary" label="Processing..."></b-spinner>
            <span class="font-weight-bolder font-size-h6">
              Extracting data from uploaded files... <span v-if="extractionJob && extractionJob.progress"><b-badge><strong>{{ extractionJob.progress }}% completed.</strong></b-badge></span><br/>
              <span v-if="extractionJob.estimatedTimeMins > 0">Estimated remaining time: <b-badge><strong>{{extractionJob.estimatedTimeMins}} minutes.</strong></b-badge><br/></span>
              You can close this page now, and come back later to check the status of the job.
            </span>
          </div>
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>

<style lang="scss">
</style>

<script>
import FormData from "form-data";
import KTUtil from "@/assets/js/components/util";

export default {
  name: "ClaimsExtractor",
  components: {},

  props: {
    title: String,
    extractionJob: Object
  },

  data() {
    return {
      errorAlert: null,
      selectedFiles: null
    };
  },

  methods: {
    uploadFiles: async function() {
      this.errorAlert = null;
      if(!this.selectedFiles || this.selectedFiles.length === 0) {
        this.errorAlert = 'Please select at least one file to upload.';
        return;
      }

      if(this.extractionJobRunning) {
        // TODO Show warning about starting a new job
      }

      this.$emit('uploadClaimsHistoryFiles', this.selectedFiles);
      this.selectedFiles = null;
    }
  },
  computed: {
    extractionJobRunning: function () {
      return this.extractionJob && this.extractionJob.status !== 'completed';
    }
  }
};
</script>
